export enum Role {
  ADMIN = "ADMIN",
  DISTRIBUTOR = "DISTRIBUTOR",
  INSTRUMENT_TECHNICIAN = "INSTRUMENT_TECHNICIAN",
  QUALITY = "QUALITY",
  OPERATOR = "OPERATOR",
}
